import { getAnnouncements } from '../../api/api'

export const actionTypes = {
  FETCH_START: 'announcements/FETCH_START',
  FETCH_SUCCESS: 'announcements/FETCH_SUCCESS',
  FETCH_ERROR: 'announcements/FETCH_ERROR',
}

export const fetchAnnouncements = () => async (dispatch) => {
  dispatch({ type: actionTypes.FETCH_START })

  try {
    const { data } = await getAnnouncements()
    return dispatch({ type: actionTypes.FETCH_SUCCESS, payload: data })
  } catch (error) {
    return dispatch({ type: actionTypes.FETCH_ERROR })
  }
}
